enum PackageType {
  CURATED = 'C',
  REGULAR = 'O',
}

export default PackageType;
